function setTimezoneCookie() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  document.cookie = "timezone=" + timezone + ";"
}

export default setTimezoneCookie
